import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { checkUserValuationAccess, createUserRecord } from '../services/firestoreService';
import Login from './Login';
import ValuationExhausted from './ValuationExhausted';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }: ProtectedRouteProps) => {
  const { currentUser, loading } = useAuth();
  const [valuationAccess, setValuationAccess] = useState<boolean | null>(null);
  const [checkingAccess, setCheckingAccess] = useState(false);

  useEffect(() => {
    const checkAccess = async () => {
      if (currentUser && !checkingAccess && valuationAccess === null) {
        setCheckingAccess(true);
        try {
          console.log('Checking access for user:', currentUser.uid);
          
          // Create user record if they don't exist
          await createUserRecord(
            currentUser.uid,
            currentUser.email || '',
            currentUser.displayName || ''
          );
          
          // Check if they can access valuation
          const canAccess = await checkUserValuationAccess(currentUser.uid);
          console.log('Access result:', canAccess);
          setValuationAccess(canAccess);
        } catch (error) {
          console.error('Error checking valuation access:', error);
          // In case of error, allow access (fail-safe)
          setValuationAccess(true);
        } finally {
          setCheckingAccess(false);
        }
      }
    };

    checkAccess();
  }, [currentUser]); // Removed checkingAccess from dependencies

  if (loading || checkingAccess) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-[#9600ff] text-white">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white mx-auto mb-4"></div>
          <p>Loading...</p>
          {checkingAccess && <p className="text-sm opacity-70 mt-2">Checking access...</p>}
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Login />;
  }

  // If user has already viewed their valuation, show exhausted page
  if (valuationAccess === false) {
    return <ValuationExhausted />;
  }

  return <>{children}</>;
};

export default ProtectedRoute; 